export default __webpack_public_path__ + "static/media/prf.063fc711.pdf";